import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-4" }
const _hoisted_2 = { class: "text-4xl" }
const _hoisted_3 = { class: "border border-collapse rounded" }
const _hoisted_4 = {
  key: 0,
  class: "flex flex-col gap-4 border-b bg-gray-200 p-4"
}
const _hoisted_5 = { class: "flex flex-col gap-2 items-center" }
const _hoisted_6 = { class: "grid text-center grid-cols-2 gap-x-4 gap-y-2" }
const _hoisted_7 = { class: "col-span-2" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-star-fill text-yellow-500" }, null, -1)
const _hoisted_9 = { class: "font-semibold text-lg" }
const _hoisted_10 = { class: "font-bold text-xl" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, "/5", -1)
const _hoisted_12 = { class: "text-gray-500" }
const _hoisted_13 = { class: "font-semibold" }
const _hoisted_14 = { class: "font-bold text-lg" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", null, "/5", -1)
const _hoisted_16 = { class: "font-semibold" }
const _hoisted_17 = { class: "font-bold text-lg" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", null, "/5", -1)
const _hoisted_19 = { class: "font-semibold" }
const _hoisted_20 = { class: "font-bold text-lg" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", null, "/5", -1)
const _hoisted_22 = { class: "font-semibold" }
const _hoisted_23 = { class: "font-bold text-lg" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", null, "/5", -1)
const _hoisted_25 = { class: "border-b p-2 grid grid-col-1 md:grid-cols-3 gap-2 md:flex-row" }
const _hoisted_26 = { class: "flex items-center gap-1" }
const _hoisted_27 = { class: "divide-y border-b" }

import PCalendar from "primevue/calendar";
import PRating from "primevue/rating";
import { computed, onBeforeMount, ref } from "vue";
import Review from "./review.vue";
import PPaginator from "primevue/paginator";
import CSwitch from "@/components/shared/Switch.vue";
import Filter from "@/components/shared/Filter.vue";
import { useToast } from "primevue/usetoast";
import { useI18n } from "vue-i18n";
import { useStore } from "vuex";
import { debounce } from "lodash";
import { DateTimeToISOString } from "@/assets/utils/date";

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const { t } = useI18n();
const toast = useToast();
const store = useStore();
const isLoading = ref(false);
const result = ref();
const selectedPosList = ref();
const isShowDetailsofAllReviews = ref(false);
const selectedDateRange = ref();
const filterPos = () => {
  retrieveReviews({});
};
const selectDateRange = async () => {
  if (selectedDateRange.value?.length > 0) {
    await retrieveReviews({});
  }
};
const clearSelectedDateRange = async () => {
  selectedDateRange.value = undefined;
  await retrieveReviews({});
};
const debounceFilterPos = debounce(filterPos, 500);
const posList = computed(() => {
  return store.getters["pos/userAccess"] ?? [];
});
const toggleDetailsofAllReviews = () => {
  isShowDetailsofAllReviews.value = !isShowDetailsofAllReviews.value;
  console.log(isShowDetailsofAllReviews.value);
};

const retrieveReviews = async ({ page = 1 }) => {
  toast.add({
    severity: "info",
    summary: t("loading"),
  });
  isLoading.value = true;

  let startDate;
  let endDate;
  if (selectedDateRange.value) {
    startDate = DateTimeToISOString(selectedDateRange.value[0]);
    endDate = DateTimeToISOString(selectedDateRange.value[1]);
  }
  const params: Record<string, unknown> = {
    page,
    posIds: selectedPosList.value?.length ? selectedPosList.value : undefined,
    startDate,
    endDate,
  };

  result.value = await store.dispatch("tenant/RETRIEVE_REVIEWS", params);

  isLoading.value = false;
  toast.removeAllGroups();
};

const changePage = async (pageState) => {
  await retrieveReviews({
    page: pageState.page + 1,
  });
};

onBeforeMount(async () => {
  await retrieveReviews({});
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t("reviews")), 1),
    _createElementVNode("div", _hoisted_3, [
      (result.value?.averageRating)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t("globalRating")), 1),
                  _createTextVNode("  "),
                  _createElementVNode("span", _hoisted_10, _toDisplayString(result.value.averageRating.globalRating), 1),
                  _hoisted_11,
                  _createTextVNode("  "),
                  _createElementVNode("span", _hoisted_12, "(" + _toDisplayString(result.value.averageRating.totalReviews) + " " + _toDisplayString(_ctx.$t("reviews")) + ") ", 1)
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t("atmosphere")), 1),
                  _createTextVNode("  "),
                  _createElementVNode("span", _hoisted_14, _toDisplayString(result.value.averageRating.atmosphere), 1),
                  _hoisted_15
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t("food")), 1),
                  _createTextVNode("  "),
                  _createElementVNode("span", _hoisted_17, _toDisplayString(result.value.averageRating.food), 1),
                  _hoisted_18
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t("qualityPriceRatio")), 1),
                  _createTextVNode("  "),
                  _createElementVNode("span", _hoisted_20, _toDisplayString(result.value.averageRating.qualityPriceRatio), 1),
                  _hoisted_21
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.$t("service")), 1),
                  _createTextVNode("  "),
                  _createElementVNode("span", _hoisted_23, _toDisplayString(result.value.averageRating.service), 1),
                  _hoisted_24
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_25, [
        _createVNode(Filter, {
          onChange: _unref(debounceFilterPos),
          class: "max-w-full",
          "all-word": _ctx.$t('allPos'),
          options: _unref(posList),
          modelValue: selectedPosList.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedPosList).value = $event)),
          placeholder: _ctx.$t('pos')
        }, null, 8, ["onChange", "all-word", "options", "modelValue", "placeholder"]),
        _createElementVNode("div", _hoisted_26, [
          _createVNode(_unref(PCalendar), {
            "show-icon": "",
            class: "w-full",
            hourFormat: "24",
            selectionMode: "range",
            modelValue: selectedDateRange.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedDateRange).value = $event)),
            manualInput: false,
            placeholder: _ctx.$t('filterByDateRange'),
            "hide-on-range-selection": "",
            onHide: selectDateRange
          }, null, 8, ["modelValue", "placeholder"]),
          (selectedDateRange.value)
            ? (_openBlock(), _createElementBlock("i", {
                key: 0,
                class: "pi pi-times border rounded-full p-1 block",
                onClick: clearSelectedDateRange
              }))
            : _createCommentVNode("", true)
        ]),
        _createVNode(CSwitch, {
          onClick: toggleDetailsofAllReviews,
          modelValue: isShowDetailsofAllReviews.value,
          class: "md:justify-self-end"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("showAllReviewsDetails")), 1)
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_27, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(result.value?.data, (reservation, reservationIndex) => {
          return (_openBlock(), _createBlock(Review, {
            class: "p-2",
            reservation: reservation,
            isShowDetails: isShowDetailsofAllReviews.value,
            key: reservationIndex
          }, null, 8, ["reservation", "isShowDetails"]))
        }), 128))
      ]),
      _createElementVNode("div", null, [
        (result.value)
          ? (_openBlock(), _createBlock(_unref(PPaginator), {
              key: 0,
              class: _normalizeClass({ 'disabled-content': isLoading.value }),
              template: "FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink",
              currentPageReportTemplate: "{currentPage} / {totalPages}",
              "total-records": result.value?.totalCount,
              rows: result.value?.pageSize,
              modelValue: result.value.currentPage,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((result.value.currentPage) = $event)),
              "page-link-size": 10,
              onPage: changePage
            }, null, 8, ["class", "total-records", "rows", "modelValue"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})